import React from 'react';
import { CONTACT_MAILTO, CAPABILIA_GREEN } from './landingConstants';

export const LandingCTA = () => (
  <section className="max-w-5xl mx-auto px-6 py-20 text-center" data-testid="landing-final-cta">
    <h2 className="font-manrope text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
      ¿Listo para reducir la deserción en tu institución?
    </h2>
    <p className="text-base text-gray-600 mb-8 max-w-xl mx-auto">
      Contanos sobre tu programa y te mostramos Persistencia 360 funcionando con tus propios datos.
    </p>
    <a
      href={CONTACT_MAILTO}
      className="inline-block font-semibold px-8 py-3 rounded-full text-white transition-transform hover:scale-105"
      style={{ backgroundColor: CAPABILIA_GREEN }}
      data-testid="landing-final-cta-btn"
    >
      Contactanos
    </a>
  </section>
);
